import { client } from "../client/client";

export const uploadIdentification = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await client.post("/kyc-validation/kenya-id", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
